// material-ui
import React, { useEffect, useState } from 'react';

// project imports
import ReusableList from 'ui-component/lhp-components/List';
import { Content, ListProps } from 'types/list';
import { getDevicesAsyncConfig, getDeviceByIDAsync } from 'service/device-service';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Button,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    Input,
    InputLabel,
    NativeSelect,
    OutlinedInput,
    Radio,
    RadioGroup,
    Select,
    TextField,
    TypeAction,
    Typography
} from '@mui/material';
import { gridSpacing } from 'store/constant';
import SubCard from 'ui-component/cards/SubCard';
import useAuth from 'hooks/useAuth';
import { getConfigAsync, updateConfigAsync, sendDMRequest } from 'service/bdr-service';
import { getDMAsync, getOnlineAsync } from 'service/upload-file-service';

const DM = () => {
    localStorage.setItem('currentPage', '/dm');

    const [content, setContent] = React.useState<ListProps>({
        title: 'Nothing Selected',
        content: { data: [], headers: [] },
        allowCSVExport: false
    });

    const [deviceID, setDeviceID] = useState<any[]>([]);
    const [selectedDeviceID, setSelectedDeviceID] = useState<string>('');

    const { logout, user } = useAuth();
    const [userName, setUserName] = useState<any>('');

    const [fileName, setFileName] = useState<any[]>([]);
    const [fileUrl, setFileUrl] = useState<any[]>([]);
    const [fileDate, setFileDate] = useState<any[]>([]);
    const [deviceOnline, setDeviceOnline] = useState<boolean>(false);
    const [lastSeen, setLastSeen] = useState<string>('');

    useEffect(() => {
        setUserName(user?.email);

        const fetchDropDowns = async () => {
            try {
                const devicesResponse = await getDevicesAsyncConfig();
                const customersResponse: Set<string> = new Set();
                const devicesIDResponse: Set<string> = new Set();

                // devicesResponse.forEach((device: any) => {
                //     customersResponse.add(device.Customer);
                // });

                devicesResponse.forEach((device: any) => {
                    devicesIDResponse.add(device.TCU_ID);
                });

                setDeviceID(Array.from(devicesIDResponse).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' })));
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };
        fetchDropDowns();
    }, []);

    const handleDeviceChange = async (_event: any, value: string) => {
        var online = await getOnlineAsync(value);
        console.log(online);
        console.log(online.data.qLresult);
        console.log(online.data.qLastseen);
        setDeviceOnline(online.data.qLresult);
        setLastSeen(online.data.qLastseen);
        setSelectedDeviceID(value);
    };

    const handleGetDM = (e: any) => {
        sendDMRequest(selectedDeviceID);
    };

    const handleGetFile = async (e: any) => {
        const response = await getDMAsync(selectedDeviceID);
        setFileName(response.data.dmName);
        setFileUrl(response.data.dmURL);
        setFileDate(response.data.dmDate);
    };

    return (
        <div>
            {user?.role == 'admin' ? (
                <div>
                    <div>
                        <Autocomplete
                            key={'selectedDeviceID'}
                            disableClearable
                            options={deviceID}
                            getOptionLabel={(option: any) => option}
                            value={selectedDeviceID}
                            onChange={handleDeviceChange}
                            //defaultValue={[]}
                            style={{ width: '15rem' }}
                            renderInput={(params) => <TextField {...params} />}
                        />
                        <br></br>
                        {selectedDeviceID != '' ? (
                            <div>
                                {deviceOnline ? (<h1 style={{ color: 'green' }}>Online</h1>) : (<h1 style={{ color: 'red' }}>Offline</h1>)} Last seen {lastSeen} {/*eslint-disable-line*/}
                            </div>
                        ) : (
                            <div></div>
                        )}
                        <br></br>
                        <Button
                            variant="contained"
                            component="label"
                            onClick={handleGetDM}
                            disabled={!deviceOnline && selectedDeviceID == ''}
                        >
                            {deviceOnline == true ? 'Pull DMs' : 'Queue DMs'}
                        </Button>
                    </div>
                    <div>
                        <br></br>
                        <Button variant="contained" component="label" onClick={handleGetFile}>
                            Get Latest File
                        </Button>
                        <br></br>
                        <div>
                            <br></br>
                            {fileName}
                            <br></br>
                            <a href={fileUrl.toString()} rel="noreferrer">
                                {fileUrl}
                            </a>
                            <br></br>
                            {fileDate}
                        </div>
                    </div>
                </div>
            ) : (
                <div>
                    <h1>Under Development</h1>
                </div>
            )}
        </div>
    );
};

export default DM;
